import React, { FC, useEffect, useState }             from "react";
import { useDispatch }                                from "react-redux";
import { useHistory }                                 from "react-router";
import { Pagination as PlanPagination }               from "semantic-ui-react";
import DeletePlan                                     from "../../../application/usecase/plan/DeletePlan";
import GetPlans                                       from "../../../application/usecase/plan/GetPlans";
import GetPlansCount                                  from "../../../application/usecase/plan/GetPlansCount";
import UpdatePlanStatus                               from "../../../application/usecase/plan/UpdatePlanStatus";
import CurrentPage                                    from "../../../domain/fundamentals/pagination/CurrentPage";
import Pagination                                     from "../../../domain/fundamentals/pagination/Pagination";
import MenuType                                       from "../../../domain/menu/MenuType";
import PlanId                                         from "../../../domain/plan/PlanId";
import Plans                                          from "../../../domain/plan/Plans";
import PlanStatusType                                 from "../../../domain/plan/PlanStatusType";
import { setPlanPaginationAction, usePlanPagination } from "../../../infrastructure/redux/plan/pagination";
import AddButton                                      from "../../components/button/AddButton";
import LeftPositionSection                            from "../../components/common/layout/LeftPositionSection";
import RightPositionSection                           from "../../components/common/layout/RightPositionSection";
import OfficeSelector                                 from "../../components/common/OfficeSelector";
import BaseLayout                                     from "../../components/layout/BaseLayout";
import PlanListTable                                  from "../../components/plan/PlanListTable";

const PlanListPage: FC = () => {
  const history = useHistory();
  const pagination = usePlanPagination();
  const dispatch = useDispatch();
  const [plans, setPlans] = useState(new Plans());
  const [count, setCount] = useState(0);

  const getPlans: GetPlans = new GetPlans(dispatch);
  const getPlansCount: GetPlansCount = new GetPlansCount();
  const deletePlan: DeletePlan = new DeletePlan(dispatch);
  const updatePlanStatus: UpdatePlanStatus = new UpdatePlanStatus(dispatch);

  useEffect(() => {
    getPlans.execute(pagination).then(value => {
      setPlans(value.plans);
      dispatch(setPlanPaginationAction(value.pagination));
    });
    getPlansCount.execute().then(value => setCount(value));
  }, []);

  return (
    <>
      <BaseLayout
        menuType={ MenuType.PLAN }
        headerTitle="プラン一覧"
      >
        <LeftPositionSection style={ {marginBottom: "1rem"} }>
          <section style={ {width: "100%"} }>
            <AddButton
              onClick={ () => history.push("/plan/add") }
              label="プランを新しく作成する"
            />
          </section>
          <RightPositionSection>
            <OfficeSelector/>
          </RightPositionSection>
        </LeftPositionSection>
        <PlanListTable
          plans={ plans }
          count={ count }
          deletePlan={ async (planId: PlanId) => {
            await deletePlan.execute(planId);
            getPlans.execute(pagination).then(value => {
              setPlans(value.plans);
              dispatch(setPlanPaginationAction(value.pagination));
            });
            getPlansCount.execute().then(value => setCount(value));
          } }
          updatePlanStatus={ async (planId: PlanId, statusType: PlanStatusType) => {
            await updatePlanStatus.execute(planId, statusType);
            getPlans.execute(pagination).then(value => {
              setPlans(value.plans);
              dispatch(setPlanPaginationAction(value.pagination));
            });
            getPlansCount.execute().then(value => setCount(value));
          } }
        />
        <PlanPagination
          totalPages={ pagination.current.value }
          activePage={ pagination.current.value }
          onPageChange={ (event, data) => {
            const newPagination = new Pagination(new CurrentPage(Number(data.activePage)), pagination.total);
            getPlans.execute(newPagination);
            dispatch(setPlanPaginationAction(newPagination));
          } }
        />
      </BaseLayout>
    </>
  );
};

export default PlanListPage;
